import { createContext } from "react";

export  const DataStore = createContext();

